<ds-listable-object-component-loader [object]="mdRepresentation"
                                     [viewMode]="viewMode"></ds-listable-object-component-loader>
